// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8927) return "static/chunks/8927-e3e6dd8b814aaf8f.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2937 ? "eabe11fc" : chunkId) + "." + {"1167":"0b3a37b4ca98e967","1171":"a1e630c91cbc0a10","2937":"5e6f1007026be5ab","3136":"95543ffbdb480df2","3622":"b5dcebd4294b1b32","5359":"042c3e30e3d046d5","7054":"014c980cd4ecac53"}[chunkId] + ".js";
};